export default "__VITE_ASSET__ILpyQ8Ca__"